(function () {'use strict';}());

angular.module('app')
  .controller('QAController', function ($scope,$q,$document,AppService,$rootScope) {
  	var trace = angular.trace;

  	$scope.qadata = {selectedQuestions:{},selectedSuspects:{}};
  	$scope.currentAnswer = null;
  	$scope.currentQuestion = null;
    $scope.currentQuestionIndex = 0;
  	$scope.currentSuspect = null;
  	$scope.numAttempts = 0;
  	$scope.choiceAllowed = false;
    $scope.answered = false;
    $scope.mode = "inspecting"; // inspecting or solveing
    $scope.playerHasChosenSuspect = false;


  	$scope.$watch("currentMinigame",onMinigameSelection);

  	$scope.onQuestionSelect = function(){
      var index = $scope.currentQuestionIndex;
  		var questions = $scope.currentMinigame.questions;
  		var question = questions[index];
      if($scope.inactive) return;

      

  		//$scope.qadata.selectedQuestions[index] === true ? "disabled" : null;
  		$scope.currentAnswer = question.answer;
  		$scope.currentQuestion = question;
      if(question.selected) return;

      question.selected = true;
  		$scope.numAttempts++;
      $scope.updateTelepathy($scope.numAttempts);
      $rootScope.$emit("audio","Speech_Bubble");
  	};
  	$scope.onSuspectSelect = function(index, target){

        var suspects = $scope.currentMinigame.suspects;
        if($scope.inactive) return;

        if($scope.checkState(index, target)){
           if(suspects[index] === $scope.currentSuspect) $scope.currentSuspect = null;
           if(suspects[index] === $scope.currentSuspect) $scope.mode = "inspecting";
            suspects[index].ruledOut = !suspects[index].ruledOut;
            if(suspects[index].ruledOut) 
            {
              $rootScope.$emit("audio","Crossing_Out_Suspect");
              if(!$scope.currentSuspect) $scope.mode = "inspecting";
            }

        } else {
          if(suspects[index].ruledOut) return;
      		//$scope.currentSuspect = suspects[index];
        }

       //Chrome bug fix... this is pretty stupid
       $document.find("#app-container").get(0).scrollTop = 0;
  	};
    $scope.chooseSuspect = function(index){
      var suspects = $scope.currentMinigame.suspects;
      if(suspects[index].ruledOut) return;
      
      if($scope.currentSuspect === suspects[index]) 
      {
        $scope.mode = "inspecting";
        $scope.currentSuspect = null;
      }
      else 
      {
        $scope.mode = "solving";
        $scope.currentSuspect = suspects[index];
      }
    };

    $scope.isDisabled = function(){
      return $scope.inactive ? true : false;
    };
    $scope.dismiss = function(){
      $scope.currentAnswer = null;
      if($scope.playerHasChosenSuspect) evaluateCompletion();
    };

  	$scope.checkState = function(index,target){
  		var items = $scope.currentMinigame[target];
  		var item = items[index];
      if($scope.inactive) return true;
  		if(target === "questions") return (item.selected || $scope.numAttempts === $scope.currentMinigame.maxattempts || $scope.answered) ? true : false;
  		else if(target === "suspects" && item.selected) return true;
      else return !$scope.choiceAllowed;
  	};
    $scope.checkComplete = function(){
      return $scope.numAttempts === $scope.currentMinigame.maxattempts || $scope.answered;
    };

    $scope.getSuspectClasses = function(item){
      if(!item.selected) return "";
      if(item.selected && item.correct) return "correct";
      if(item.selected && !item.correct) return "incorrect";
    };

    $scope.showResponse = function(){
      var index = $scope.currentQuestionIndex;
      var disabled = $scope.checkState(index,"questions");
      var question = $scope.currentMinigame.questions[index];
      if($scope.inactive) return;
      if(disabled && question.selected) $scope.currentAnswer = question.answer;
    };


    $scope.solvePuzzle = function(){
        $scope.mode = "solving";
        $scope.choiceAllowed = true;
    };

    $scope.select = function(){
      var audio = null;
      var answer = null;
      if($scope.playerHasChosenSuspect === true) return;

      $scope.answered = $scope.currentSuspect.correct;
      $scope.playerHasChosenSuspect = true;

      if($scope.answered){
          answer = $scope.currentSuspect.response;
          $scope.inactive = true;
          audio = "Win_Game";
      } else{
          answer = "I'm sorry, that's not me! Good luck on your journey, I must go...";
          audio = "Lose_Game";
          $scope.drawDownHours(4);
      }

      $rootScope.requestAudio("Button_Confirm").then(function(){
        $rootScope.$emit("audio",audio);
      });
      $scope.currentAnswer = answer;
    };


    $scope.onContinue = function(){
        if(__STANDALONE__){
          $scope.currentAdventure.complete = true;
          $scope.setCurrentPage($scope.PAGE_THEME_SELECTION);
        }
        else{
          $scope.setGeocacheCallback(evaluateCompletion);
        }
        
    };

    $scope.playAgain = function(){
      reset();
    };

    $scope.nextQuestion = function(){
      if($scope.currentQuestionIndex < $scope.currentMinigame.questions.length - 1){
        $scope.currentQuestionIndex++;
      }
      else{
        $scope.currentQuestionIndex = 0;
      }
      
      $scope.currentQuestion = $scope.currentMinigame.questions[$scope.currentQuestionIndex];
      $rootScope.$emit("audio","Switch_out_Question");
    };  
    $scope.prevQuestion = function(){
      if($scope.currentQuestionIndex > 0){
        $scope.currentQuestionIndex--;
      }
      else{
        $scope.currentQuestionIndex =  $scope.currentMinigame.questions.length - 1;
      }
      
      $scope.currentQuestion = $scope.currentMinigame.questions[$scope.currentQuestionIndex];
      $rootScope.$emit("audio","Switch_out_Question");
    };

    $scope.getQuestionPosition = function(index){
      if(index === $scope.currentQuestionIndex) return "center";
      if(index < $scope.currentQuestionIndex) return "left";
      if(index > $scope.currentQuestionIndex) return "right";
    };

  	function onMinigameSelection(value){
  		if(!value) return;
  		if(value.type !== "qa") return;

        var evt = {
            eventCategory: "GRTT: Mini Game",
            eventLabel: "GRTT: " + value.title
        };
        gtag("event", "GRTT: start", evt);

      reset();

  	}

    function reset(){

      if(!$rootScope.QAHelpView){
        $rootScope.QAHelpView = true;
        $scope.help();
      }
      

      $scope.qadata = {selectedQuestions:{},selectedSuspects:{}};
      $scope.currentAnswer = null;
      $scope.currentQuestion = null;
      $scope.currentSuspect = null;
      $scope.numAttempts = 0;
      $scope.choiceAllowed = false;
      $scope.answered = false;
      $scope.mode = "inspecting"; // inspecting or solveing
      $scope.playerHasChosenSuspect = false;
      $scope.inactive = false;
      $scope.currentQuestionIndex = 0;

      $scope.img = $scope.currentMinigame.img;

      var items = $scope.currentMinigame.questions.concat($scope.currentMinigame.suspects);
      var i,count;
      for(i = 0, count = items.length; i < count; i++){
        items[i].selected = false;
      }

      var suspects = $scope.currentMinigame.suspects;
      for(i = 0, count = suspects.length; i < count; i++){
        suspects[i].ruledOut = false;
      }

      var evt = {
          eventCategory: "GRTT: Mini Game",
          eventLabel:  "GRTT: " + $scope.currentMinigame.title
      };
      gtag("event", "GRTT: start", evt);

    }

    function evaluateCompletion(){
      var deferred,resetCallback;

      if($scope.answered)
      {
        $scope.inactive = true;
        deferred = $q.defer();
        deferred.promise.then(returnToMenu);
        $scope.currentLocation.isCorrect = true;
        $scope.setCurrentArtifact($scope.currentLocation.artifact,deferred);

        var evt = {
            eventCategory: "GRTT: Mini Game",
            eventLabel:  "GRTT: " + $scope.currentMinigame.title
        };
        gtag("event", "GRTT: end - complete", evt);

        return true;
      }
      else if($scope.numAttempts === $scope.currentMinigame.maxattempts || $scope.playerHasChosenSuspect){
        $scope.inactive = true;
        deferred = $q.defer();
        deferred.promise.then(returnToMenu);
        var evt2 = {
            eventCategory: "GRTT: Mini Game",
            eventLabel:  "GRTT: " + $scope.currentMinigame.title
        };
        gtag("event", "GRTT: end - incomplete", evt2);

        if($scope.hoursRemaining >= 4){
          resetCallback = $q.defer();
          resetCallback.promise.then(reset);
        }
        $scope.currentAnswer = "No, that's not me.";
        if(__STANDALONE__){
          $scope.setCurrentPage($scope.PAGE_THEME_SELECTION);
        }
        else{
          $scope.setCurrentFeedback("current feedback object",deferred,resetCallback);
        }
        
        return true;
      }
      return false;
    }

    function returnToMenu(){
      $scope.setCurrentPage($scope.currentLocation.isCorrect ? $scope.PAGE_ARTIFACT_COLLECTION : $scope.PAGE_MAP);
    }

  });
